<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.THERMOMETER_TOOLS.TITLE' | translate }}</h4>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.THERMOMETER_TOOLS.FUNDRAISING_TARGET' | translate }}</mat-label>
    <input matInput type="number" [formControl]="fundraisingTargetControl" min="0" />
  </mat-form-field>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="thermometerBackgroundColorControl"
    labelTranslateKey="PRESENTER.THERMOMETER_TOOLS.THERMOMETER_BACKGROUND_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="thermometerBorderColorControl"
    labelTranslateKey="PRESENTER.THERMOMETER_TOOLS.THERMOMETER_BORDER_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="thermometerColorControl"
    labelTranslateKey="PRESENTER.THERMOMETER_TOOLS.THERMOMETER_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-presenter-tools-advanced-options-container>
    <mat-slide-toggle [formControl]="trackPledgesOnlyControl">
      {{ 'PRESENTER.THERMOMETER_TOOLS.TRACK_PLEDGES_ONLY' | translate }}
    </mat-slide-toggle>

    <mat-slide-toggle [formControl]="baseTotalRaisedEnabledControl">
      {{ 'PRESENTER.THERMOMETER_TOOLS.BASE_TOTAL_RAISED_ENABLED' | translate }}
    </mat-slide-toggle>

    <gb-image-upload-button
      labelText="PRESENTER.THERMOMETER_TOOLS.CUSTOM_IMAGE"
      buttonText="SHARED.IMAGE_UPLOADER.SELECT_IMAGE"
      backdropColor="var(--gb-background-color-400)"
      [showEmptyImageArea]="true"
      (openUploadDialog)="openCustomImageUploadDialog()"
      [images]="customImages"
      [maxWidth]="4000"
      [maxHeight]="4000"
      [cover]="true"
      [isMulti]="false"
      [secondaryButtonText]="customImages.length ? 'CLEAR' : ''"
      (secondaryButtonClicked)="clearCustomImage()"
    ></gb-image-upload-button>

    @if (!isTemplateMode) {
      <button mat-stroked-button type="button" class="filter-teams-button" (click)="openFilterItemsDialog()">
        <span class="button-inner">
          <gb-icon icon="filter" height="18px"></gb-icon>
          <span>{{ 'PRESENTER.ITEM_TABLE_TOOLS.FILTER_ITEMS.BUTTON' | translate }}</span>
        </span>
      </button>

      @if (excludedItemsCount > 0) {
        <button type="button" class="excluded-items-link" (click)="openExcludedItemsDialog()">
          {{
            (excludedItemsCount === 1
              ? 'PRESENTER.ITEM_TABLE_TOOLS.EXCLUDED_ITEMS.COUNT_SINGULAR'
              : 'PRESENTER.ITEM_TABLE_TOOLS.EXCLUDED_ITEMS.COUNT'
            ) | translate: { count: excludedItemsCount }
          }}
        </button>
      }
    }
  </gb-presenter-tools-advanced-options-container>
</div>
